import { sliderClose, sliderToggle } from "../common/sliderFunctions.js";

import {
    getNormalizedTextContent,
    getFirstAlphabeticalLetter,
    scrollToElement,
} from "../common/helpers";

const sortByTitle = (a, b) => {
    if (a.title < b.title) {
        return -1;
    }

    if (a.title > b.title) {
        return 1;
    }

    return 0;
};

const toggleActiveClass = ($el) => {
    if ($el.classList.contains("active")) {
        $el.classList.remove("active");
    } else {
        $el.classList.add("active");
    }
};

const getLetterClass = (letter) => {
    return `js-ns-glossary-letter-${letter}`;
};

const ALPHABET = [..."abcdefghijklmnopqrstuvwxyz"];

export const useGlossary = () => {
    const glossaries = document.querySelectorAll(".js-ns-glossary");

    const initElement = ($container) => {
        const $navigation = $container.querySelector(
            ".js-ns-glossary-navigation"
        );
        const $content = $container.querySelector(".js-ns-glossary-content");
        const $navigationItemTemplate = $container.querySelector(
            ".js-ns-glossary-navigation-item-template"
        );
        const $blockTemplate = $container.querySelector(
            ".js-ns-glossary-block-template"
        );
        const items = $container.querySelectorAll(".js-ns-glossary-item");

        if (!items || !items.length) {
            return;
        }

        const data = [...items].reduce((accum, $item) => {
            const $title = $item.querySelector(".js-ns-glossary-item-title");

            const title = getNormalizedTextContent($title.textContent);
            const firstLetter = getFirstAlphabeticalLetter(title);
            const firstLetterLowercase = firstLetter.toLowerCase();
            const result = {
                title,
                $el: $item,
            };

            if (accum[firstLetterLowercase]) {
                return {
                    ...accum,
                    [firstLetterLowercase]: [
                        ...accum[firstLetterLowercase],
                        result,
                    ],
                };
            }

            return {
                ...accum,
                [firstLetterLowercase]: [result],
            };
        }, {});

        ALPHABET.forEach((letter) => {
            const $clone = $navigationItemTemplate.content.cloneNode(true);
            const $item = $clone.querySelector(
                ".js-ns-glossary-navigation-item"
            );

            $item.textContent = letter;

            if (data[letter]) {
                $item.classList.add("active");
            }

            $item.addEventListener("click", () => {
                const letterClass = getLetterClass(letter);
                const $target = $container.querySelector(`.${letterClass}`);

                if (!$target) {
                    return;
                }

                scrollToElement($target);
            });

            $navigation.append($item);
        });

        const sortedKeys = Object.keys(data).sort();

        sortedKeys.forEach((letter) => {
            const items = data[letter];
            const $blockClone = $blockTemplate.content.cloneNode(true);
            const $blockLetter = $blockClone.querySelector(
                ".js-ns-glossary-letter"
            );
            const $blockList = $blockClone.querySelector(
                ".js-ns-glossary-list"
            );

            $blockLetter.textContent = letter;
            $blockLetter.classList.add(getLetterClass(letter));

            const sortedItems = items.sort(sortByTitle);

            sortedItems.forEach((item) => {
                const { $el } = item;
                const $title = $el.querySelector(".js-ns-glossary-item-title");
                const $content = $el.querySelector(
                    ".js-ns-glossary-item-content"
                );

                $el.remove();

                $el.classList.remove("hidden");

                $blockList.append($el);

                $title.addEventListener("click", () => {
                    Object.keys(data).forEach((letter) => {
                        const items = data[letter];

                        items.forEach((item) => {
                            const $sibling = item.$el;

                            if ($el === $sibling) {
                                return;
                            }

                            const $title = $sibling.querySelector(
                                ".js-ns-glossary-item-title"
                            );

                            const $content = $sibling.querySelector(
                                ".js-ns-glossary-item-content"
                            );

                            $title.classList.remove("active");

                            sliderClose($content, 500);
                        });
                    });

                    toggleActiveClass($title);
                    sliderToggle($content, 500);
                });
            });

            $content.append($blockClone);
        });
    };

    const init = () => {
        if (!glossaries || !glossaries.length) {
            return;
        }

        glossaries.forEach(($el) => initElement($el));
    };

    const initGlossary = () => {
        document.addEventListener("DOMContentLoaded", init);
    };

    return {
        initGlossary,
    };
};
